"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRuntime = void 0;
// For client-side SDKs, machine IP and Hostname are not captured and sent to Split backend.
function validateRuntime() {
    return {
        ip: false,
        hostname: false
    };
}
exports.validateRuntime = validateRuntime;
